module.exports = __webpack_public_path__ + "static/media/shopping-mall.20bcf5d4.jpg";